(function (app) {
    app.AttributeSelection = {
        init() {
            const attributeSelectEls = document.querySelectorAll('.wdpp-select--attribute');
            const attributeDisplayEls = document.querySelectorAll('.wdpp-display--attribute');

            // Validate required elements
            if (!app.Utils.validateElements('attribute inputs', {
                'attribute select elements': attributeSelectEls,
                'attribute display elements': attributeDisplayEls
            })) {
                return;
            }

            // Initialize attributes array in store
            app.Store.setState('attributes', []);

            // Subscribe to attribute changes
            app.Store.subscribe('attributes', (attributes) => {
                if (attributes) {
                    attributes.forEach((attribute, index) => {
                        const displayEl = attributeDisplayEls[index];
                        const selectEl = attributeSelectEls[index];
                        if (displayEl && selectEl) {
                            const selectedOption = Array.from(selectEl.options).find(opt => 
                                JSON.stringify(JSON.parse(opt.value)) === JSON.stringify(attribute)
                            );
                            if (selectedOption) {
                                displayEl.textContent = selectedOption.textContent;
                            }
                        }
                    });
                }
            });

            // Initialize each attribute selector
            attributeSelectEls.forEach((attributeSelectEl, index) => {
                const attributeDisplayEl = attributeDisplayEls[index];
                if (!attributeDisplayEl) {
                    console.error(`Missing display element for attribute selector ${index}: (.wdpp-display--attribute[data-index="${index}"])`);
                    return;
                }

                // Set initial attribute in store
                const initialAttribute = JSON.parse(attributeSelectEl.value);
                const attributes = app.Store.getState('attributes') || [];
                attributes[index] = initialAttribute;
                app.Store.setState('attributes', attributes);

                // Initialize display content
                const selectedOption = attributeSelectEl.options[attributeSelectEl.selectedIndex];
                if (selectedOption) {
                    attributeDisplayEl.textContent = selectedOption.textContent;
                }

                // Set up change event for each selector
                attributeSelectEl.addEventListener('change', function () {
                    const newAttribute = JSON.parse(this.value);
                    Array.from(this.options).forEach(option => {
                        option.removeAttribute('selected');
                    });

                    const selectedIndex = this.selectedIndex;
                    if (selectedIndex >= 0) {
                        this.options[selectedIndex].setAttribute('selected', '');

                        // Update store
                        const currentAttributes = app.Store.getState('attributes') || [];
                        currentAttributes[this.getAttribute('data-index')] = newAttribute;
                        app.Store.setState('attributes', currentAttributes);
                    }
                });

                // Trigger initial attribute change event
                app.Store.subscribe('initialized', () => {
                    app.Store.setState('selectAttribute', {
                        attribute: attributeSelectEl.value,
                        index: attributeSelectEl.getAttribute('data-index')
                    });
                });
            });
        },

        /**
         * Get the attribute data for cart export
         * @returns {object} The attribute data for the cart
         */
        getCartData() {
            const attributes = app.Store.getState('attributes') || [];
            const data = {
                attributes: {}
            };

            attributes.forEach((attribute, index) => {
                data.attributes[index] = {
                    attribute: attribute
                };
            });

            return data;
        },

        /**
         * Get the attribute data for price calculation
         * @returns {object} The attribute data for the price
         */
        getPriceData() {
            const attributes = app.Store.getState('attributes') || [];
            const data = {
                attributes: {}
            };

            attributes.forEach((attribute, index) => {
                data.attributes[index] = {
                    attribute: attribute
                };
            });

            return data;
        }
    };
})(window.app = window.app || {});